import { render, staticRenderFns } from "./OrgAppro.vue?vue&type=template&id=5331111d"
import script from "./OrgAppro.vue?vue&type=script&lang=js"
export * from "./OrgAppro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports